/**
 * Компонент выбора tenant: для SuperAdmin - dropdown, для Employee - readonly badge
 * Дата: 28.12.2025 - Создан для TODO-013 (Templates Page)
 * Связан с: frontend/src/pages/Templates.tsx, frontend/src/api/tenants.ts
 */
import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Select, Badge } from '@/components/ui';
import { tenantsApi } from '@/api/tenants';

interface Tenant {
  id: string;
  name: string;
  slug: string;
}

interface TenantSelectorProps {
  value?: string;
  onChange?: (tenantId: string) => void;
  required?: boolean;
  testId?: string;
  showLabel?: boolean; // Дата: 09.01.2026 - Добавлено для inline размещения
}

export function TenantSelector({ value, onChange, required, testId, showLabel = true }: TenantSelectorProps) {
  const { user } = useAuth();
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const isSuperAdmin = !user?.tenant_id;

  useEffect(() => {
    if (isSuperAdmin) {
      tenantsApi.list().then((data) => setTenants(data.tenants || [])).catch(() => {});
    }
  }, [isSuperAdmin]);

  if (!isSuperAdmin) {
    // Tenant Employee: показываем readonly badge
    return (
      <div>
        {showLabel && (
        <label className="block text-sm font-medium text-neutral-700 mb-1">
          Клиника
        </label>
        )}
        <Badge variant="secondary">{user?.tenant_id || 'Не указана'}</Badge>
      </div>
    );
  }

  // SuperAdmin: dropdown
  return (
    <Select
      label={showLabel ? "Клиника" : undefined}
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      options={[
        { value: '', label: required ? 'Выберите клинику' : 'Все клиники' },
        ...tenants.map(t => ({ value: t.id, label: t.name }))
      ]}
      required={required}
      testId={testId}
    />
  );
}

